import { __assign } from "tslib";
import { StyleParamType, } from '../../../types';
import { generateKey } from '../../../generateKey';
import { paramShouldInheritDesktop } from '../../../utils/paramShouldInheritDesktop';
export function createStyleParamDefaultValueGetter(_a) {
    var styles = _a.styles, textPresets = _a.textPresets, colors = _a.colors, dimensions = _a.dimensions, experiments = _a.experiments, options = _a.options;
    var isMobile = options.isMobile, isRTL = options.isRTL, isEditorX = options.isEditorX, styleParamsPerBreakpointMode = options.styleParamsPerBreakpointMode;
    return function (param) {
        var _a;
        return (_a = param.getDefaultValue) === null || _a === void 0 ? void 0 : _a.call(param, {
            colors: colors,
            textPresets: textPresets,
            isMobile: isMobile,
            isRTL: isRTL,
            isEditorX: isEditorX,
            dimensions: dimensions,
            experiments: experiments,
            getStyleParamValue: function (depParam, options) {
                if (options === void 0) { options = {}; }
                var getParam = createStyleParamGetter(__assign({ storage: styles, colors: colors, textPresets: textPresets, isMobile: isMobile, isRTL: isRTL, isEditorX: isEditorX, dimensions: dimensions, experiments: experiments, styleParamsPerBreakpointMode: styleParamsPerBreakpointMode }, options));
                return getParam(depParam);
            },
        });
    };
}
export function createStyleParamGetter(_a) {
    var styles = _a.storage, textPresets = _a.textPresets, _b = _a.colors, colors = _b === void 0 ? [] : _b, isMobile = _a.isMobile, isRTL = _a.isRTL, isEditorX = _a.isEditorX, dimensions = _a.dimensions, experiments = _a.experiments, styleParamsPerBreakpointMode = _a.styleParamsPerBreakpointMode;
    var getParamValue = createStoredStyleParamGetter({
        storage: styles,
        isMobile: isMobile,
        styleParamsPerBreakpointMode: styleParamsPerBreakpointMode,
    });
    return function (param) {
        var paramValue = getParamValue(param);
        if (typeof paramValue === 'undefined' && param.getDefaultValue) {
            var getDefaultValue = createStyleParamDefaultValueGetter({
                styles: styles,
                textPresets: textPresets,
                colors: colors,
                dimensions: dimensions,
                experiments: experiments,
                options: {
                    isMobile: isMobile,
                    isRTL: isRTL,
                    isEditorX: isEditorX,
                    styleParamsPerBreakpointMode: styleParamsPerBreakpointMode,
                },
            });
            return getDefaultValue(param);
        }
        return paramValue;
    };
}
export function createStoredStyleParamGetter(_a) {
    var _b;
    var styles = _a.storage, isMobile = _a.isMobile, styleParamsPerBreakpointMode = _a.styleParamsPerBreakpointMode;
    var getNumberParam = function (key) {
        return (styles.numbers || {})[key];
    };
    var getBooleanParam = function (key) {
        return (styles.booleans || {})[key];
    };
    var getFontParam = function (key) {
        return (styles.fonts || {})[key];
    };
    var getColorParam = function (key) {
        return (styles.colors || {})[key];
    };
    var getStringParam = function (key) {
        return (styles.strings || {})[key];
    };
    var getterMap = (_b = {},
        _b[StyleParamType.Number] = getNumberParam,
        _b[StyleParamType.Boolean] = getBooleanParam,
        _b[StyleParamType.Font] = getFontParam,
        _b[StyleParamType.Color] = getColorParam,
        _b[StyleParamType.String] = getStringParam,
        _b);
    return function (param) {
        var value;
        var key = param.key || param.name;
        var getter = getterMap[param.type];
        if (styleParamsPerBreakpointMode) {
            value = getter(key);
        }
        else {
            var generatedKey = generateKey(__assign(__assign({}, param), { key: key }), { isMobile: isMobile });
            value = getter(generatedKey);
            var shouldInheritDesktop = paramShouldInheritDesktop(param);
            if (generatedKey !== key &&
                shouldInheritDesktop &&
                typeof value === 'undefined') {
                value = getter(key);
            }
        }
        return value;
    };
}
//# sourceMappingURL=createStyleParamGetter.js.map